import LogoutForm from './LogoutForm';
import LogoutIntro from './LogoutIntro';

export default function LogoutContent() {
  return (
    <div className='space-above'>
      <LogoutIntro />
      <LogoutForm />
    </div>
  );
}

